export default "__VITE_PUBLIC_ASSET__7572cbb6__"